'use client';

import { createClient } from '@/lib/supabase/client';

interface PartnershipApplicationData {
  organizationName: string;
  organizationType: string;
  country: string;
  website: string;
  contactName: string;
  contactEmail: string;
  contactPhone?: string;
  description: string;
  focusAreas: string[];
  partnershipGoals: string;
}

function isSchemaError(error: any): boolean {
  if (!error) return false;
  
  if (error.code && typeof error.code === 'string') {
    const errorClass = error.code.substring(0, 2);
    if (errorClass === '42' || errorClass === '08') {
      return true;
    }
    if (errorClass === '23') {
      return false;
    }
  }
  
  if (error.message) {
    const schemaErrorPatterns = [
      /relation.*does not exist/i,
      /column.*does not exist/i,
      /function.*does not exist/i,
      /syntax error/i,
      /invalid.*syntax/i,
      /type.*does not exist/i,
      /undefined.*column/i,
      /undefined.*table/i,
    ];
    return schemaErrorPatterns.some(pattern => pattern.test(error.message));
  }
  
  return false;
}

export const partnerNetworkService = {
  async submitApplication(data: PartnershipApplicationData) {
    const supabase = createClient();

    try {
      const { data: result, error } = await supabase
        .from('partnership_applications')
        .insert({
          organization_name: data.organizationName,
          organization_type: data.organizationType,
          country: data.country,
          website: data.website,
          contact_name: data.contactName,
          contact_email: data.contactEmail,
          contact_phone: data.contactPhone || null,
          description: data.description,
          focus_areas: data.focusAreas,
          partnership_goals: data.partnershipGoals,
        })
        .select()
        .single();

      if (error) {
        if (isSchemaError(error)) {
          console.error('Schema error:', error.message);
          throw error;
        } else {
          console.log('Data error:', error.message);
          return null;
        }
      }

      return result;
    } catch (error: any) {
      console.log('Schema-related error:', error.message);
      throw error;
    }
  },
};